export default "__VITE_ASSET__yBBUBWzT__"